import PropTypes from 'prop-types';
import React from 'react';

class LocalErrorBoundary extends React.PureComponent {
  static getDerivedStateFromError(error) {
    return { error };
  }

  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  clearError = () => this.setState({ error: null });

  render() {
    if (this.state.error) {
      const { FallbackComponent } = this.props;
      return FallbackComponent ? <FallbackComponent error={this.state.error} clearError={this.clearError} /> : null;
    }
    return this.props.children;
  }
}

LocalErrorBoundary.propTypes = {
  FallbackComponent: PropTypes.func,
  children: PropTypes.any,
};

export default LocalErrorBoundary;
